import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "preserveappearancefromlayoutenum"
    }}>{`PreserveAppearanceFromLayoutEnum`}</h1>
    <p>{`Preserve Appearance from Layout Options`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PRESERVE_APPEARANCE_DEFAULT`}</strong>{` = 1349665893`}</p>
      <p parentName="blockquote">{`Export preferences will be honoured`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PRESERVE_APPEARANCE_USE_EXISTING_IMAGE`}</strong>{` = 1349670245`}</p>
      <p parentName="blockquote">{`Exiting image will be used`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PRESERVE_APPEARANCE_RASTERIZE_CONTAINER`}</strong>{` = 1349669490`}</p>
      <p parentName="blockquote">{`Container & content both will be rasterized, if can be`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PRESERVE_APPEARANCE_RASTERIZE_CONTENT`}</strong>{` = 1349669492`}</p>
      <p parentName="blockquote">{`Content will be rasterized, if can be`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      